<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    append-to-body
    :show-close="false"
    width="62.5%"
    center
  >
    <dialog-header
      slot="title"
      :title="$t('carMonitor.terminalBatch.taskDetail')"
      :icon="'icon-dialog-add'"
      @close="closeDialog"
    />
    <app-search>
      <div slot="content">
        <el-row :gutter="10" type="flex" justify="start" align="middle">
          <el-col :span="8">
            <el-form :label-position="'right'" :model="listQuery" label-width="90px">
              <el-form-item :label="$t('public.obdCode')+'：'">
                <el-input
                  v-model="listQuery.barcode"
                  :placeholder="$t('public.obdCode')"
                  clearable
                />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>

    <div style="padding: 10px 0;position: relative;">
      <el-button v-waves type="primary" @click="handleSubmit">{{$t('public.cancelTask')}}</el-button>
      <div style="position: absolute;right: 0;top: 10px" class="add-btn-right">
        <el-button class="custom-button"  style="background: transparent;color: #409EFF"  v-waves type="primary" @click="handleExport">
          <svg-icon icon-class="icon-export" />
        {{$t('public.export')}}
        </el-button>
      </div>
      
    </div>
    <!-- table -->
    <div style="min-height:40vh">
      <el-table
        ref="tableList"
        show-overflow-tooltip
        v-loading="listLoading"
        size="mini"
        :data="list"
        :max-height="tableHeight"
        :header-row-style="headerRowStyle"
        :row-style="rowStyle"
        :header-cell-style="headerCellStyle"
        border
        fit
        highlight-current-row
        style="width: 100%"
        @row-click="clickRow"
        @select="rowSelect"
        @select-all="selectAll"
      >
        <el-table-column type="selection" :selectable="selectable"  width="55" align="center" />
        <el-table-column :label="$t('table.id')" align="center" width="65">
          <template slot-scope="scope">
            <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item,index) in tableList"
          :key="index"
          :label="item.value"
          :prop="item.prop"
          :align="item.position"
          :min-width="item.width"
          :sortable="item.sortable"
        >
          <el-table-column
            v-for="(v,i) in item.children || []"
            :key="i"
            :label="v.value"
            :prop="v.prop"
            :align="v.position"
            :width="v.width"
          >
            <template slot-scope="scope">
              <div>
                <span
                  @click="cancelCommond(scope.row,v)"
                  v-if="v.prop.indexOf('operationStatus')>-1"
                  :style="styleObject(scope.row[v.prop])"
                  :class="scope.row[v.prop]==0? 'borderBottom': ''"
                >
                  <svg-icon
                    :icon-class="scope.row[v.prop]===0 ? 'icon-weizhixing':scope.row[v.prop]===1 ?'icon-zhixingzhong' : 'icon-zhiixngok'  "
                  />

                  <el-popover
                    v-if="scope.row[v.prop]==0"
                    placement="top-start"
                    width="90"
                    trigger="hover"
                    :visible-arrow="false"
                    :content="$t('public.clickCancle')"
                  >
                    <span slot="reference">{{ scope.row[v.prop] | switchText }}</span>
                  </el-popover>
                  <span v-else>{{ scope.row[v.prop] | switchText }}</span>
                </span>

                <span v-else>{{ scope.row[v.prop] }}</span>
              </div>
            </template>
          </el-table-column>
          <template slot-scope="scope">
            <div>
              <span v-if="item.prop==='status'" :style="styleObject(scope.row[item.prop])">
                <svg-icon
                  :icon-class="scope.row[item.prop]===0 ? 'icon-weizhixing':scope.row[item.prop]===1 ? 'icon-zhixingzhong': 'icon-zhiixngok' "
                />
                {{ scope.row[item.prop] | switchText }}
              </span>
              <div v-else-if="item.prop==='licensePlate'">
                <vue-licenseplate
                  :types="0"
                  :licensepalte="scope.row[item.prop]"
                  :area="scope.row['areaName']"
                />
              </div>
              <div
                v-else-if="item.prop==='isOnline'"
                :class="scope.row[item.prop]===1 ? 'yesgps':'nogps'"
              >
                <svg-icon :icon-class="scope.row[item.prop]===1 ? 'online-start':'online-end'" />
                {{ scope.row[item.prop] == 0 ? $t('public.other.no') : $t('public.other.yes') }}
              </div>
              <span v-else-if="item.prop==='remark'">
                <el-popover
                  placement="top-start"
                  width="230"
                  trigger="hover"
                  :visible-arrow="false"
                  :content="scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/')"
                >
                  <span
                    slot="reference"
                  >{{ scope.row[item.prop] || (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}</span>
                </el-popover>
              </span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="padding:10px" :class="[total>0?'visible':'hidden','pagination-container']">
        <el-pagination
          :current-page="listQuery.pageNum"
          :page-sizes="[10,20,30,50]"
          :page-size="listQuery.pageSize"
          :total="total"
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button
        v-waves
        class="dialog-cancel"
        type="primary"
        @click="handlecancle"
      >{{$t('public.cancel')}}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{$t('public.cancelTask')}}</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
// 混入
import { pagingMixin } from "@/mixins/table"
import { tableStyle } from "@/mixins/tableStyle"
// request
import {
  getBatchRemoteSettingDetailsPageList,
  getParamCount,
  exportTask,
  cancelCommond,
  cancelList,
} from "@/api/carMonitor/terminalBatch"
// 组件
export default {
  name: "LookTaskDialog",
  filters: {
    switchText(val) {
      switch (val) {
        case -1:
          return vm.$t("carMonitor.terminalBatch.yichexiao")
        case 0:
          return vm.$t("carMonitor.terminalBatch.notperformed")
        case 1:
          return vm.$t("carMonitor.terminalBatch.Inprogress")
        case 2:
          return vm.$t("carMonitor.terminalBatch.Finishedperformed")
        case 3:
          return vm.$t("carMonitor.terminalBatch.failedcount")
        case 4:
          return vm.$t("carMonitor.terminalBatch.tingzx")
        default:
          return vm.$t("carMonitor.terminalBatch.weizhi")
      }
    },
  },
  mixins: [pagingMixin, tableStyle],
  props: {
    visibles: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      listQuery: {
        licensePlate: "",
        carTypeId: "",
      },
     
      batchCodeList: [],
      carTypeList: [],
      showfilter: false,
      list: [],
      total: 0,
      tableHeight: 0,
      listLoading: false,
      tableList: [
        {
          value: this.$t("public.obdCode"),
          prop: "barcode",
          width: 150,
          position: "center",
        },
        {
          value: this.$t("carMonitor.terminalBatch.allStatus"),
          prop: "status",
          position: "center",
          width: 150,
        },
        {
          value: this.$t(
            "carMonitor.monitorinfo.carStatus.whetherterminalisonline"
          ),
          prop: "isOnline",
          position: "center",
          width: 120,
        },
        {
          value: this.$t("carMonitor.terminalBatch.createtime"),
          prop: "createtime",
          position: "center",
          width: 150,
        },
        {
          value: this.$t("public.endTime"),
          prop: "finishTime",
          position: "center",
          width: 150,
        },
      ],
      selectList: [],
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.listLoad()
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight * 0.5
    })
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight * 0.5
      })
    }
  },
  methods: {
    styleObject(e) {
      return {
        color:
          e == -1
            ? "gray"
            : e == 1
            ? "green"
            : e === 2
            ? "#00E56C"
            : e === 3 || e === 4
            ? "red"
            : "#606266",
      }
    },
    selectable(row) {
      if (row.unExecuted === 0) {
        return false
      } else {
        return true
      }
    },
    listLoad() {
      if (!this.visibles) {
        return
      }
      getParamCount({ taskid: this.data.oid })
        .then(({ data }) => {
          if (data.code === 0) {
            const fileNum = data.data
            this.listLoading = true
            this.listQuery.taskId = this.data.oid
            this.tableList = [
              {
                value: this.$t("public.obdCode"),
                prop: "barcode",
                width: 150,
                position: "center",
              },
              {
                value: this.$t("carMonitor.terminalBatch.allStatus"),
                prop: "status",
                position: "center",
                width: 150,
              },
              {
                value: this.$t(
                  "carMonitor.monitorinfo.carStatus.whetherterminalisonline"
                ),
                prop: "isOnline",
                position: "center",
                width: 120,
              },
              {
                value: this.$t("carMonitor.terminalBatch.createtime"),
                prop: "createTime",
                position: "center",
                width: 150,
              },
              {
                value: this.$t("public.endTime"),
                prop: "finishTime",
                position: "center",
                width: 150,
              },
            ]
            getBatchRemoteSettingDetailsPageList(this.listQuery)
              .then(({ data }) => {
                this.list = []
                if (data.code === 0) {
                  if (fileNum === 1) {
                    const obj = {
                      value: this.$t("carMonitor.terminalBatch.ml"),
                      position: "center",
                      children: [
                        {
                          value: this.$t("carMonitor.terminalBatch.taskName"),
                          prop: "commandName",
                          position: "center",
                          width: 130,
                        },
                        {
                          value: this.$t("carMonitor.terminalBatch.mlParames"),
                          prop: "param",
                          position: "center",
                          width: 150,
                        },
                        {
                          value: this.$t("carMonitor.terminalBatch.wancheng"),
                          prop: "operationStatus",
                          index: 0,
                          position: "center",
                          width: 130,
                        },
                        {
                          value: this.$t("public.note"),
                          prop: "remark",
                          position: "center",
                          width: 150,
                        },
                      ],
                    }
                    this.tableList.splice(this.tableList.length - 2, 0, obj)
                  } else {
                    for (let i = 1; i < fileNum + 1; i++) {
                      const obj = {
                        value: this.$t("carMonitor.terminalBatch.ml") + i,
                        position: "center",
                        children: [
                          {
                            value: this.$t("carMonitor.terminalBatch.taskName"),
                            prop: "commandName" + i,
                            position: "center",
                            width: 130,
                          },
                          {
                            value: this.$t(
                              "carMonitor.terminalBatch.mlParames"
                            ),
                            prop: "param" + i,
                            position: "center",
                            width: 150,
                          },
                          {
                            value: this.$t("carMonitor.terminalBatch.wancheng"),
                            prop: "operationStatus" + i,
                            index: i,
                            position: "center",
                            width: 130,
                          },
                          {
                            value: this.$t("public.note"),
                            prop: "remark" + i,
                            position: "center",
                            width: 150,
                          },
                        ],
                      }
                      this.tableList.splice(this.tableList.length - 2, 0, obj)
                    }
                  }
                  this.list = data.data
                  this.total = data.total
                }
                this.listLoading = false
              })
              .catch(() => {
                this.listLoading = false
              })
          }
        })
        .catch(() => {
          this.listLoading = false
        })
    },
    restData() {
      this.listQuery.barcode = ""
      this.listQuery.carTypeId = ""
      this.listQuery.pageSize = 10
      this.listQuery.pageNum = 1
      this.batchCodeList = []
      this.carTypeList = []
      this.list = []
      this.selectList = []
      this.tableList = [
        // { value: this.$t('public.licensePlate'), prop: 'licensePlate', width: 150, position: 'center' },
        {
          value: this.$t("public.obdCode"),
          prop: "barcode",
          width: 150,
          position: "center",
        },
        {
          value: this.$t("carMonitor.terminalBatch.allStatus"),
          prop: "status",
          position: "center",
          width: 150,
        },
        {
          value: this.$t(
            "carMonitor.monitorinfo.carStatus.whetherterminalisonline"
          ),
          prop: "isOnline",
          position: "center",
          width: 120,
        },
        {
          value: this.$t("carMonitor.terminalBatch.createtime"),
          prop: "createTime",
          position: "center",
          width: 150,
        },
        {
          value: this.$t("public.endTime"),
          prop: "finishTime",
          position: "center",
          width: 150,
        },
      ]
    },
    handleClear() {
      for (const k in this.listQuery) {
        if (k === "pageNum" || k === "pageSize" || k === "taskId") {
          continue
        } else {
          this.listQuery[k] = ""
        }
      }
    },
    closeDialog() {
      this.restData()
      this.$emit("update:visibles", false)
    },
    handleExport() {
      exportTask(this.listQuery)
    },
    cancelCommond(item, v) {
      const index = v.index
      const operationStatus =
        index === 0 ? item.operationStatus : item["operationStatus" + index]
      const commandId =
        index === 0 ? item.commandId : item["commandId" + index]
      if (operationStatus === 0) {
        this.$confirm(
          this.$t("public.cancelTaskTips"),
          this.$t("public.tips"),
          {
            confirmButtonText: this.$t("public.define"),
            cancelButtonText: this.$t("public.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            cancelCommond({ id: commandId }).then(({ data }) => {
              if (data.code === 0) {
                this.listLoad()
              }
            })
          })
          .catch(() => {})
      }
    },
    clickRow(row) {
      const index = this.selectList.findIndex(
        (item) => item.barcode === row.barcode
      )
      if (index > -1) {
        this.selectList.splice(index, 1)
      } else {
        this.selectList.push(row)
      }
      this.$refs.tableList.toggleRowSelection(row)
    },
    rowSelect(selection, row) {
      const index = this.selectList.findIndex(
        (item) => item.barcode === row.barcode
      )
      if (index > -1) {
        this.selectList.splice(index, 1)
      } else {
        this.selectList.push(row)
      }
    },
    selectAll(selection) {
      // 此时反选
      if (selection.length === 0) {
        for (let i = 0; i < this.list.length; i++) {
          const index = this.selectList.findIndex(
            (item) => item.barcode === this.list[i].barcode
          )
          if (index > -1) {
            this.selectList.splice(index, 1)
          }
        }
      } else {
        for (let i = 0; i < this.list.length; i++) {
          this.selectList.push(this.list[i])
        }
      }
    },
    handlecancle() {
      this.closeDialog()
    },
    handleSubmit() {
      if (this.selectList.length > 0) {
        const postData = {
          taskId: this.data.oid,
          barCode: this.selectList.map((v) => v.barcode)
        }
        this.$confirm(
          this.$t("public.cancelAllTaskTips"),
          this.$t("public.tips"),
          {
            confirmButtonText: this.$t("public.define"),
            cancelButtonText: this.$t("public.cancel"),
            type: "warning",
          }
        )
        .then(() => {
          cancelList(postData).then(({ data }) => {
              if (data.code === 0) {
                this.$emit("cancelSuccess")
                this.$message.success({
                  message: this.$t('public.success'),
                  duration: 2 * 1000
                })
                this.closeDialog()
              }
          })
        })
        .catch(() => {})

      }
    },
  },
}
</script>

<style lang="scss" scoped>
.yesgps {
  color: rgb(64, 109, 64);
}
.nogps {
  color: #98a3af;
}
.borderBottom {
  border-bottom: 1px solid rgb(96, 98, 102);
  cursor: pointer;
}
.custom-button:hover{
  background: #fff !important;
}
</style>
